<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" >
      <TabPane name="1" label="绩效计件管理" v-if="p('managerReckonSwth/list')">
        <c1></c1>
      </TabPane>
      <TabPane name="2" label="店面评级" v-if="p('storeFrontGrade/findStoreFrontGradeList')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="元数据配置" v-if="p('meta/metaListByPage')">
        <c3></c3>
      </TabPane>
      <TabPane name="4" label="业绩公式" v-if="p('formula/allFormula')">
        <c4></c4>
      </TabPane>
      <TabPane name="5" label="公式配置" v-if="p('formulaConf/formulaConfListByPage')">
        <c5></c5>
      </TabPane>
      <TabPane name="6" label="元数据分配" v-if="p('metaPermission/metaPermissionListByPage')">
        <c6></c6>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/performance/manager/index'
  import C2 from '@/views/performance/grade/index'
  import C3 from '@/views/performance/rule/metaconfig/index'
  import C4 from '@/views/performance/rule/performula/index'
  import C5 from '@/views/performance/rule/formulaconfig/index'
  import C6 from '@/views/performance/rule/metadistribution/index'
  import {mixin} from "../../mixin";


  export default {
    name:'performance',
    components:{
      C1,
      C2,
      C3,
      C4,
      C5,
      C6,
    }        ,
    mixins:[mixin],
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
